export enum AggregationLevel {
    none = 'none',
    county = 'landkreise',
    governmentDistrict = 'regierungsbezirke',
    state = 'bundeslaender',
    country = 'laender'
}
